import { provideHttpClient } from '@angular/common/http';
import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import {
  IconsContainerBundledStrategy,
  provideIconsContainerStrategy,
} from '@core/user-interface-legacy';

import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import { provideProductUpdatesConfig } from './app/config/product-updates-config.provider';
import { environment } from './environments/environment';

if (environment.angularProdMode) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(),
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),
    provideProductUpdatesConfig(environment),
    provideIconsContainerStrategy({ useClass: IconsContainerBundledStrategy }),
  ],
}).catch(err => console.error(err));
